"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TickerReservation = void 0;
const internal_1 = require("../../../internal");
const types_1 = require("../../../types");
const conversion_1 = require("../../../utils/conversion");
const internal_2 = require("../../../utils/internal");
/**
 * Represents a reserved Asset symbol in the Polymesh blockchain. Ticker reservations expire
 *   after a set length of time, after which they can be reserved by another Identity.
 *   A Ticker must be previously reserved by an Identity for that Identity to be able create an Asset with it
 */
class TickerReservation extends internal_1.Entity {
    /**
     * @hidden
     */
    constructor(identifiers, context) {
        super(identifiers, context);
        const { ticker } = identifiers;
        (0, internal_2.assertTickerValid)(ticker);
        this.ticker = ticker;
        this.extend = (0, internal_2.createProcedureMethod)({
            getProcedureAndArgs: () => [internal_1.reserveTicker, { ticker, extendPeriod: true }],
            voidArgs: true,
        }, context);
        this.createAsset = (0, internal_2.createProcedureMethod)({
            getProcedureAndArgs: args => [internal_1.createAsset, Object.assign(Object.assign({}, args), { ticker, reservationRequired: true })],
        }, context);
        this.transferOwnership = (0, internal_2.createProcedureMethod)({ getProcedureAndArgs: args => [internal_1.transferTickerOwnership, Object.assign({ ticker }, args)] }, context);
    }
    /**
     * @hidden
     * Check if a value is of type {@link UniqueIdentifiers}
     */
    static isUniqueIdentifiers(identifier) {
        const { ticker } = identifier;
        return typeof ticker === 'string';
    }
    // eslint-disable-next-line require-jsdoc
    details(callback) {
        return __awaiter(this, void 0, void 0, function* () {
            const { context: { polymeshApi: { query: { asset }, }, }, ticker, context, } = this;
            const rawTicker = (0, conversion_1.stringToTicker)(ticker, context);
            const assembleResult = (reservationOpt, tokenOpt, assetId) => {
                let owner = null;
                let status = types_1.TickerReservationStatus.Free;
                let expiryDate = null;
                if (tokenOpt.isSome) {
                    status = types_1.TickerReservationStatus.AssetCreated;
                    const rawOwnerDid = tokenOpt.unwrap().ownerDid;
                    owner = new internal_1.Identity({ did: (0, conversion_1.identityIdToString)(rawOwnerDid) }, context);
                    return {
                        owner,
                        expiryDate,
                        status,
                        assetId: assetId,
                    };
                }
                if (reservationOpt.isSome) {
                    const { owner: rawOwnerDid, expiry } = reservationOpt.unwrap();
                    owner = new internal_1.Identity({ did: (0, conversion_1.identityIdToString)(rawOwnerDid) }, context);
                    expiryDate = expiry.isSome ? (0, conversion_1.momentToDate)(expiry.unwrap()) : null;
                    if (!expiryDate || expiryDate > new Date()) {
                        status = types_1.TickerReservationStatus.Reserved;
                    }
                }
                return {
                    owner,
                    expiryDate,
                    status,
                };
            };
            let assetId;
            const meshAssetId = yield asset.tickerAssetId(rawTicker);
            const rawAssetId = meshAssetId.unwrapOrDefault();
            if (meshAssetId.isSome) {
                assetId = (0, conversion_1.assetIdToString)(meshAssetId.unwrap());
            }
            if (callback) {
                context.assertSupportsSubscription();
                return (0, internal_2.requestMulti)(context, [
                    [asset.uniqueTickerRegistration, rawTicker],
                    [asset.assets, rawAssetId],
                ], ([registration, token]) => {
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises -- callback errors should be handled by the caller
                    callback(assembleResult(registration, token, assetId));
                });
            }
            const [tickerRegistration, meshAsset] = yield (0, internal_2.requestMulti)(context, [
                [asset.uniqueTickerRegistration, rawTicker],
                [asset.assets, rawAssetId],
            ]);
            return assembleResult(tickerRegistration, meshAsset, assetId);
        });
    }
    /**
     * Determine whether this Ticker Reservation exists on chain
     */
    exists() {
        return __awaiter(this, void 0, void 0, function* () {
            const { ticker, context: { polymeshApi: { query: { asset }, }, }, context, } = this;
            const tickerSize = yield asset.uniqueTickerRegistration.size((0, conversion_1.stringToTicker)(ticker, context));
            return !tickerSize.isZero();
        });
    }
    /**
     * Return the Reservation's ticker
     */
    toHuman() {
        return this.ticker;
    }
}
exports.TickerReservation = TickerReservation;
//# sourceMappingURL=index.js.map